<template>
    <div v-if="model" class="model-info wrapper">
        <div class="breadcrumb">
            <router-link :to="backUrl">TALENTS</router-link>
            > <strong class="orange">{{ model.Voornaam }} {{ model.Achternaam_letter }}</strong></div>
        <h1>{{ model.Voornaam }} {{ model.Achternaam_letter }}</h1>
        <div class="info">
            <table class="column" v-if="windowWidth > 400">
                <tr>
                    <td>Model ID</td>
                    <td>: {{ model.Referentienummer }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.category') }}</td>
                    <td>: {{ model.Klasse }} <span v-if="proposalId"> - {{ model.Nivo }}</span></td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.age') }}</td>
                    <td>: {{ model.Leeftijd }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.length') }}</td>
                    <td>: {{ model.Lengte }}</td>
                </tr>
            </table>
            <table class="column" v-if="windowWidth > 400">
                <tr>
                    <td>{{ trans('talents.profile.ready_to_wear') }}</td>
                    <td>: {{ model.Confectie }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.shoe_size') }}</td>
                    <td>: {{ model.Schoen }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.hair_colour') }}</td>
                    <td>: {{ model.Haarkleur }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.eye_colour') }}</td>
                    <td>: {{ model.Ogen }}</td>
                </tr>
            </table>
            <table class="column" v-if="windowWidth < 400">
                <tr>
                    <td>{{ trans('talents.profile.category') }}</td>
                    <td>: {{ model.Klasse }} <span v-if="proposalId"> - {{ model.Nivo }}</span></td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.age') }}</td>
                    <td>: {{ model.Leeftijd }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.length') }}</td>
                    <td>: {{ model.Lengte }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.ready_to_wear') }}</td>
                    <td>: {{ model.Confectie }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.shoe_size') }}</td>
                    <td>: {{ model.Schoen }}</td>
                </tr>
            </table>
            <div class="column" v-if="windowWidth < 400"></div>
            <table class="column">
                <tr>
                    <td colspan="2" class="btns">
                        <div v-if="!isFavorite(model.ID_Model)" class="btn-orange add-to-selection" @click.stop="addToFavorites(model.ID_Model)">{{ trans('talents.profile.add_to_selection') }} <span class="plus">+</span></div>
                        <div v-if="isFavorite(model.ID_Model)" class="btn-quiet remove-from-selection" @click.stop="removeFromFavorites(model.ID_Model, (mode === 'talents' || mode === 'proposal'))">{{ trans('talents.profile.delete_from_selection') }} <span class="min">-</span></div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="btns"><a :href="'/model/sedcard/'+model.ID_Model" class="btn-black btn-download" :data-id="model.ID_Model">{{ trans('talents.profile.download_sedcard') }}</a></td>
                </tr>
                <tr>
                    <td class="data">{{ trans('talents.profile.last_update') }}</td>
                    <td class="data">{{ model.last_change_to_model }}</td>
                </tr>
                <tr>
                    <td class="data">{{ trans('talents.profile.last_update_pics') }}</td>
                    <td class="data">{{ model.last_changed_foto }}</td>
                </tr>
            </table>
        </div>
        <div class="images" v-if="modelfotos">
            <div class="row">
                <picture class="model-image" v-if="modelfotos[0]">
                    <source :srcset="'/models/'+modelfotos[0].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[0].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[0].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image" v-if="modelfotos[1]">
                    <source :srcset="'/models/'+modelfotos[1].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[1].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[1].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
            </div>
            <div class="row">
                <picture class="model-image white" v-if="modelfotos[2]">
                    <source :srcset="'/models/'+modelfotos[2].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[2].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[2].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image white" v-if="modelfotos[3]">
                    <source :srcset="'/models/'+modelfotos[3].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[3].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[3].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
            </div>
            <div class="row" v-if="windowWidth > 400">
                <picture class="model-image white" v-if="modelfotos[4]">
                    <source :srcset="'/models/'+modelfotos[4].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[4].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[4].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image white" v-if="modelfotos[5]">
                    <source :srcset="'/models/'+modelfotos[5].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[5].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[5].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
            </div>
            <div class="row" v-if="windowWidth > 400">
                <picture class="model-image white" v-if="modelfotos[6]">
                    <source :srcset="'/models/'+modelfotos[6].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[6].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[6].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image white" v-if="modelfotos[7]">
                    <source :srcset="'/models/'+modelfotos[7].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[7].ID_Foto+'.jpg'" type="image/jpeg">
                    <img style="width:100%;" :src="'/models/'+modelfotos[7].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
import {mapState} from 'vuex'

export default {
    props: ['index', 'listName'],

    computed: {
        ...mapState(['models']),
        ...mapState(['favorites']),
        ...mapState(['favoritesIds']),
        ...mapState(['project']),
        filters() {
            return this.$store.getters.filters()
        },
        applicationId() {
            return this.$store.getters.applicationId()
        },
        proposalId() {
            return this.$store.getters.proposalId()
        },
        backUrl() {
            return this.applicationId && this.proposalId ? '/aanvraag/' + this.applicationId + '/' + this.proposalId : '/'
        },
        model() {
            return this.currentList[this.index]
        },
        currentList() {
            return this.mode === 'favorites' ? this.favorites[this.project] : this.models //ADD IF IS THEN FAVORITES
        },
        mode() {
            return this.$store.getters.mode()
        },
        modelfotos() {
            return _.uniqBy(_.toArray(this.model.fotos), 'id')
        },
        showAllImages() {
            if (this.model.Klasse === 'Acteur' || this.model.Specialiteit === 'Hostessen' || this.model.Specialiteit === 'Families' || this.model.Specialiteit === 'Handmodellen') {
                return false
            } else {
                return true
            }
        }
    },
    methods: {},
}
</script>
